<div class="reorder-container">
  <p>Click and drag a clause to reorder it.</p>
  <p>To select multiple clauses hold the Ctrl or Shift keys whilst selecting the clauses.</p>
  <p>
    Clauses can be moved to other sections by being dragged and dropped onto the section title in the left-hand sidebar.
  </p>
  <p>To exit reorder mode, click the reorder button again.</p>
</div>
